import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { NPC, Question, NPCResponse } from '../objects/NPC';
import { TalkToNPCScene } from "./TalkToNPCScene";
import { GameState } from "../objects/GameState";
import initializeInteractiveCursor from "src/games/shared/InteractiveCursorUtil";
import { Color } from "src/games/shared/ColorValue";
import TranslateApi from "src/utils/TranslateHelper";
import { PictureWallScene } from "./PictureWallScene";
import AudioTranslations from "src/constants/AudioTranslations";
import { numKeys } from "src/constants/KeyboardNumKeys";

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    astronaut: Phaser.GameObjects.Image;
    allNPCs: NPC[];
    endScene: boolean = false;

    private translateString = "FitFive.Phaser.MainScene.";

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/fitFiveGame/fit_five_game.json"));
        this.load.atlas("assets", require("/src/assets/qci/atlas/gameFitFive.png"), require("/src/assets/qci/atlas/gameFitFive.json"));
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.image("gym", require("/src/assets/qci/backgrounds/gym.jpg"));
        this.load.image("gym-zoomed-1", require("/src/assets/qci/backgrounds/gym-zoomed-1.jpg"));
        this.load.image("gym-zoomed-2", require("/src/assets/qci/backgrounds/gym-zoomed-2.jpg"));
        this.load.image("gym-zoomed-3", require("/src/assets/qci/backgrounds/gym-zoomed-3.jpg"));
        this.load.image("gym-zoomed-4", require("/src/assets/qci/backgrounds/gym-zoomed-4.jpg"));
        this.load.image("gym-zoomed-5", require("/src/assets/qci/backgrounds/gym-zoomed-5.jpg"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
        this.bindNumKeys();
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.allNPCs = [];
        this.endScene = false;
    }

    generateScene() {
        this.background = this.add.image(0, 0, "gym");
        this.background.setOrigin(0);
        this.addNPCs();
        this.resetNPCs();
    }

    addNPCs(): void {
        var layer = this.map.getObjectLayer("NPC");
        var npcs = NPC.ALL_NPCS;
        layer.objects.forEach((ob: TiledGameObject) => {
            var labelObject = this.map.getObjectLayer("labels").objects.find((l) => l.name === ob.name) as TiledGameObject;

            var npc = npcs.find((character: NPC) => character.assetKey === ob.name);
            var npcObject = this.add.image(ob.x, ob.y, "assets", npc.assetKey);
            npcObject.setOrigin(0);
            npcObject.setDisplaySize(ob.width, ob.height);
            npcObject.setInteractive();
            npc.object = npcObject;
            npcObject.on('pointerdown', () => {
                this.clickedNPC(npc);
            });

            var name = TranslateApi.translate(npc.name);
            var job = TranslateApi.translate(npc.job);
            var labelText = (npc.id) + ': ' + name + TranslateApi.translate(this.translateString + "the") + job;

            var labelStyle = { fontSize: 14, fontFamily: 'Russo One, Arial', align: "center", backgroundColor: "#000000", padding: 10 };
            var npcLabel = this.add.text(labelObject.x, labelObject.y, labelText, labelStyle).setDepth(1);
            npcLabel.setWordWrapWidth(200, true);
            npc.label = npcLabel;
            let border = this.add.image(npcLabel.x - 2, npcLabel.y - 2, "pixel").setDisplaySize(npcLabel.displayWidth + 4, npcLabel.displayHeight + 4);
            border.setDepth(0.5).setOrigin(0).setTint(Color.PLANET_COLORS.get("S"));
            border.setInteractive();
            border.on('pointerdown', () => {
                this.clickedNPC(npc);
            });

            this.allNPCs.push(npc);
        });
    }

    clickedNPC(npc: NPC) {
        if (npc.enabled) {
            // Update GameState and go to talk to character scene
            GameState.current.currentNPC = npc;
            Question.HELLO.textID.replace("%", npc.id.toString());
            GameState.current.question = Question.HELLO;
            GameState.current.response = npc.responses.find((r: NPCResponse) => r.questionId === 0);

            this.scene.pause("MainScene");
            this.scene.add("TalkToNPCScene", TalkToNPCScene, true);
            npc.label.setTint(Color.COLORS.get('light grey'));
        }
    }

    haveTalkedToAllNPCs(): boolean {
        for (var npc of this.allNPCs) {
            if (!npc.talkedTo) {
                return false;
            }
        }
        return true;
    }

    resetNPCs(): void {
        this.allNPCs.forEach((npc: NPC) => {
            npc.enabled = true;
            npc.talkedTo = false;
            npc.picked = false;
        });
    }

    update(): void {
        if (this.haveTalkedToAllNPCs() && !this.endScene) {
            this.endScene = true;
            this.scene.remove(this);
            this.scene.add("PictureWallScene", PictureWallScene, true);
            return;
        }
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.input.keyboard.on('keydown_' + key, event);
        });
    }

    bindNumKeys(): void {
        numKeys.forEach((key) => {
            this.onKeydown(() => {
                let npc = NPC.ALL_NPCS[key.index];
                this.clickedNPC(npc);
            }, key.keyCode, key.altKeyCode);
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/FitFiveGame/scenes/MainScene.ts